import React from 'react';
import { connect } from 'react-redux';

import StockReceiptSupplierList from '../../components/StockReceiptSupplierList/StockReceiptSupplierList.web';

const SuggestedPriceByMarginScreen = (props: any) => (
  <StockReceiptSupplierList
    title={'Suggested Price By Margin SR List'}
    detailPath={'/web/stock-receipts/sugg-price-by-margin/detail/'}
    userData={props.userData}
    history={props.history}
  />
);


const mapStateToProps = (state: any) => {
  return {
    userData: state.userLocalData,
  };
};

export default connect(mapStateToProps, null)(SuggestedPriceByMarginScreen);
